/** Default z-index for menu/dropdown overlays (e.g. UIMenu). */
export const menuDefaultZIndex = 9000;

// Keep shared UI overlays above manager dialogs when rendered inside modals.
export const overlayAboveModalZIndex = 2147483100;
